import { render, staticRenderFns } from "./DailyLimitReachedCard.vue?vue&type=template&id=e68623b8&"
import script from "./DailyLimitReachedCard.vue?vue&type=script&lang=js&"
export * from "./DailyLimitReachedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports